/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Murambi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */

module.exports = {
  "Mubuga": [
    "Cyamatare",
    "Gasebeya",
    "Kazibaziba",
    "Migina",
    "Nyabivumu",
    "Nyabwoma",
    "Nyaruvumu"
  ],
  "Muhororo": [
    "Birambo",
    "Bwakira",
    "Kananira",
    "Ndago",
    "Nyabiranga",
    "Nyakabuye",
    "Tariro"
  ],
  "Nkoto": [
    "Gakoma",
    "Gisovu",
    "Kakirinda",
    "Kibamba",
    "Mataba",
    "Muramba"
  ],
  "Nyarunyinya": [
    "Gituntu",
    "Kamasambu",
    "Karambo",
    "Kigandaro",
    "Murambi",
    "Nyarusave"
  ],
  "Shyembe": [
    "Bugaramantare",
    "Gitwa",
    "Kaburega",
    "Kavumu",
    "Musibya",
    "Nyabaguma",
    "Nyabisindu",
    "Nyamagana",
    "Nyamugari",
    "Nyaruhanga"
  ]
};
